import { NavLink } from 'react-router-dom'
import { Home, CalendarDays, Users, FileUp, BarChart3, CreditCard, Settings, type LucideIcon } from 'lucide-react'
import { cn } from '@/utils/cn'
import { isMeetingImportEnabled } from '@/utils/featureFlags'

interface NavItem {
  key: string
  label: string
  to: string
  icon: LucideIcon
}

// 実ルートに接続 (R3)。詳細ページ (例 /contacts/:id) でもアクティブを維持するため
// end は付けず prefix マッチにする。
const NAV_ITEMS: NavItem[] = [
  { key: 'today', label: '今日', to: '/dashboard', icon: Home },
  { key: 'meetings', label: '会議', to: '/realtime/setup', icon: CalendarDays },
  { key: 'contacts', label: '相手', to: '/contacts', icon: Users },
  { key: 'usage', label: '使用量', to: '/usage', icon: BarChart3 },
  { key: 'billing', label: '課金', to: '/billing', icon: CreditCard },
  { key: 'settings', label: '設定', to: '/account', icon: Settings },
]

/** フラグ ON のとき「相手」(index 2) の直後に取り込みを挿入（§13-1） */
function buildNavItems(): NavItem[] {
  if (!isMeetingImportEnabled()) return NAV_ITEMS
  const items = [...NAV_ITEMS]
  items.splice(3, 0, { key: 'import', label: '取り込み', to: '/import', icon: FileUp })
  return items
}

export function SideNav({ className }: { className?: string }) {
  return (
    <nav
      aria-label="メインナビゲーション"
      className={cn(
        'flex h-full w-[88px] flex-col items-stretch gap-1 border-r border-v2-border bg-v2-surface px-2 py-4',
        className,
      )}
    >
      {buildNavItems().map(({ key, label, to, icon: Icon }) => (
        <NavLink
          key={key}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex min-h-[56px] flex-col items-center justify-center gap-1 rounded-v2-md text-xs font-medium transition-colors duration-[var(--duration-v2-base)] ease-[var(--ease-v2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-primary focus-visible:ring-offset-2',
              isActive
                ? 'bg-v2-primary-soft text-v2-primary'
                : 'text-v2-ink-muted hover:bg-v2-bg hover:text-v2-ink',
            )
          }
        >
          <Icon className="h-5 w-5" aria-hidden="true" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
